import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarditNestingReport
  from '../../components/CarditNestingReport';
import {
  getPercentageColumns,
  getNumberColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CarditNestingCarrierSelectors';
import CarditNestingCarrierReportMode from './CarditNestingCarrierReportMode';

const MODE_TABS = [
  { value: CarditNestingCarrierReportMode.percentage, label: '%' },
  { value: CarditNestingCarrierReportMode.number, label: '#' },
];

export class CarditNestingCarrierContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportMode: CarditNestingCarrierReportMode.percentage,
    };
  }

  changeMode = reportMode => this.setState({ reportMode });

  renderPercentage() {
    return (
      <CarditNestingReport
        reportId={ReportDefinitions.CARDIT_NESTING_CARRIER.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.percentageColumns}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarditNestingCarrierReportMode.percentage}
      />
    );
  }

  renderNumber() {
    return (
      <CarditNestingReport
        reportId={ReportDefinitions.CARDIT_NESTING_CARRIER.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.numberColumns}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarditNestingCarrierReportMode.number}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case CarditNestingCarrierReportMode.percentage:
        return this.renderPercentage();
      case CarditNestingCarrierReportMode.number:
        return this.renderNumber();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    percentageColumns: getPercentageColumns(state),
    numberColumns: getNumberColumns(state),
  };
}

CarditNestingCarrierContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  percentageColumns: PropTypes.arrayOf(PropTypes.object),
  numberColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CarditNestingCarrierContainer);
